'use client'
import Logo from '@/../public/logo.svg'
import { useGlobal } from '@/contexts/Global'
import { ThemeColors } from '@/tokens'
import Link from 'next/link'
import React from 'react'

export const NAVBAR_HEIGHT_PX = 89
const X_PADDING = 27

const Navbar: React.FC<{ rootHref: string }> = (props) => {
  const { pdfLayout } = useGlobal()

  return pdfLayout && window.location.pathname.includes('/member') ? null : (
    <nav
      className='flex items-center h-[60px] pl-70 pr-[27px] shadow-[3px_4px_17px_0_rgba(0,0,0,0.12)]'
      style={{
        height: NAVBAR_HEIGHT_PX,
        paddingLeft: 70,
        paddingRight: X_PADDING,
        backgroundColor: ThemeColors['light-background-1']
      }}
    >
      <Link href={props.rootHref}>
        <Logo />
      </Link>
    </nav>
  )
}

export default Navbar
